$(document).ready(function () {
  var filter, filterTarget;
  var windowsize = $(window).width();

  // $('#pagination-numbers-open-order').hide();
  $("#paginated-list").append('<tr class="od_empty non"><td colspan="5" style="padding: 70px 5px;"><p style="font-size: 11px;">NO</p></td></tr>');
  $("#mobile_order").append('<tbody class="od_empty non"><tr><td style="padding: 70px 5px; text-align: center;"><p style="font-size: 11px;">NO</p></td></tr></tbody>');
    
  $(".order_filter a").click(function () {
    //console.log("test area", $(this).text());
    var openTab = $(this).text();
    $(".order_filter_all").css("opacity", "1");
    if (openTab == "OPENED ORDERS") {
      $(".order_filter_open").removeClass("open-order-hide");
      $(".order_filter_cancel, .order_test").addClass("open-order-hide");
      var row_length = $("#paginated-list .order_filter_open");
      pagination(row_length);
      var mob_row_length = $("#mobile_order .order_filter_open");
      mobilepagination(mob_row_length);
    } else if (openTab == "CANCELLED ORDERS") {
      $(".order_filter_open, .order_test").addClass("open-order-hide");
      $(".order_filter_cancel").removeClass("open-order-hide");
      var row_length = $("#paginated-list .order_filter_cancel");
      pagination(row_length);
      var mob_row_length = $("#mobile_order .order_filter_cancel");
      mobilepagination(mob_row_length);
    } else if (openTab == "ALL") {
      $(".order_filter_all").removeClass("open-order-hide");
      var row_length = $("#paginated-list tr");
      pagination(row_length);
      var mob_row_length = $("#mobile_order .order_filter_all");
      mobilepagination(mob_row_length);
    }
    
    $(".order_filter a").removeClass("active");
    filter = $(this).attr("class");
    $(this).addClass("active");
    // mobile -------------------------------------------------------------
    if (windowsize < 768) {
      $(".account_wrap .order_fill.order_mb .order_target").removeClass(
        "active"
      );

      filterTarget = $(
        ".account_wrap .order_fill.order_mb .order_target." + filter + ""
      );
    } else {
      $(".account_wrap .order_fill.order_pc tbody .order_target").removeClass(
        "active"
      );
      filterTarget = $(
        ".account_wrap .order_fill.order_pc tbody tr.order_target." +
          filter +
          ""
      );
    }
    filterTarget.addClass("active");
    
    var check = $(".od_empty");

    $("#paginated-list .od_empty p, #mobile_order .od_empty p").text('NO '+ openTab);
    if(filterTarget.length == 0){
        $("#paginated-list .od_empty, #mobile_order .od_empty").removeClass("non");
    }else{
       $("#paginated-list .od_empty, #mobile_order .od_empty").addClass("non");
    }

  });
    var mob_row_length = $("#mobile_order .order_filter_all");
    mobilepagination(mob_row_length);
    var row_length = $("#paginated-list .order_filter_all");
    pagination(row_length);
});
// $(document).ready(function () {
//   var windowsize = $(window).width();
//   $(window).on("load resize",function(e){
//     var windowsize = $(this).width();
//       if (windowsize < 768) {
//         var mob_row_length = $("#mobile_order .order_filter_all");
//         mobilepagination(mob_row_length);
//       }else{
//         var row_length = $("#paginated-list .order_filter_all");
//         pagination(row_length);
//       }
//   });
// });
function noMargin(target,pageNum){
  if(pageNum <= 1){
    target.addClass("empty");
  }else{
    target.removeClass("empty");
  }
}
   
function pagination(row_length) {
  $("#order-pagination").html(
    '<div id="nav"><div id="orderPagination"></div></div>'
  );
  var rowsShown = 10;
  var rowsTotal = $(row_length).length;
  var numPages = Math.ceil(rowsTotal / rowsShown);
  var beforeLastPage = numPages - 1;
  //console.log('rowsTotal',rowsTotal);
  //console.log('numPages',numPages);
  //console.log('beforeLastPage',beforeLastPage);

  noMargin($(".desk_pagination"), numPages)
  console.log(numPages)
  
  for (i = 1; i <= numPages; i++) {
    $("#orderPagination").append(
      '<a class="nums" href="javascript:void(0)" rel="' + i + '">' + i + "</a> "
    );

    if (i == 1 && numPages > 4) {
      $("#orderPagination").append('<span class="leftdot">...</span>');
    }
    if (i == beforeLastPage && numPages > 4) {
      $("#orderPagination").append('<span class="rightdot">...</span>');
    }
  }

  $(row_length).hide();
  $(row_length).slice(0, rowsShown).show();
  $("#nav a:first").addClass("active");

  if (numPages >= 2) {
    $("#nav").append('<a class="next_btn" href="javascript:void(0)" rel="next"><span></span></a> ');
    $("#nav").prepend('<a class="prev_btn" href="javascript:void(0)" rel="prev"><span></span></a> ');
  }
  if (numPages > 4) {
    $("#nav").find("rightdot").show();
  }
  if (numPages <= 1) {
    $('#nav').css('display','none');
  }else{
    $('#nav').css('display','flex');
  }
  $("#orderPagination a:gt(2)").hide(); // one after

  $("#nav")
    .on("click", "a", function () {
      var pageNumber = $("#nav .nums");
      var pageLength = $("#nav .nums").length;
      var currentNumber = $(this).attr("rel");
      //console.log('currentNumber========',currentNumber);
      if(currentNumber == 1){
        $("#nav").find('.prev_btn').addClass('disable');
      }else{
        $("#nav").find('.prev_btn').removeClass('disable');
      }
      if (currentNumber == "next") {
        currentNumber = $("#nav a.active").attr("rel");
        currentNumber++;
      } else if (currentNumber == "prev") {
        currentNumber = $("#nav a.active").attr("rel");
        currentNumber--;
      }
      //console.log("numPages - currentNumber", numPages - currentNumber);
      if (currentNumber > 4) {
        $("#nav").find(".leftdot").show();
      } else {
        $("#nav").find(".leftdot").hide();
      }
      if (currentNumber < 3) {
        $("#nav").find(".rightdot").show();
      } else if (numPages - currentNumber < 3) {
        $("#nav").find(".rightdot").hide();
      } else {
        $("#nav").find(".rightdot").hide();
      }
      //console.log('currentNumber',currentNumber);
      var r = currentNumber * rowsShown;
      var i = r - rowsShown;
      //console.log('rows',r);

      $("#nav a").removeClass("active");
      $('#nav a[rel="' + currentNumber + '"]').addClass("active");
      $(row_length)
        .css("opacity", "0.0")
        .hide()
        .slice(i, r)
        .css("display", "table-row")
        .animate(
          {
            opacity: 1,
          },
          300
        );

      if (
        pageNumber.filter("#orderPagination .active").is(pageNumber.first())
      ) {
        //console.log("test area first",pageLength);
        if(pageLength <= 4){
          pageNumber.first('a').show().next('a').show().next('a').show().next('a').show();
        }else{
          pageNumber
          .first()
          .show()
          .next()
          .hide()
          .next()
          .show()
          .next()
          .show()
          .nextAll("a")
          .hide();
        }
        //pageNumber.first('a').show().next('a').show().next('a').show();
        
        $("#nav").find('.prev_btn').addClass('disable');
        $("#nav").find('.next_btn').removeClass('disable');
      } else if (
        pageNumber.filter("#orderPagination .active").is(pageNumber.last())
      ) {
        console.log("test area last");
        $("#nav").find('.prev_btn').removeClass('disable');
        $("#nav").find('.next_btn').addClass('disable');
        $("#nav").find(".rightdot").hide();
        if(pageLength <= 4){
          pageNumber.last('a').show().prev('a').show().prev('a').show().prev('a').show();
        }else{
        pageNumber
          .last()
          .show()
          .prev()
          .hide()
          .prev()
          .show()
          .prev()
          .show()
          .prevAll("a")
          .hide();
        }
      } else {
        if (numPages - currentNumber > 3) {
          $("#nav").find(".rightdot").show();
        } else if (currentNumber == 4) {
          $("#nav").find(".rightdot").hide();
        } else {
          $("#nav").find(".rightdot").hide();
        }
        console.log("test area out");
        $("#nav").find('.prev_btn, .next_btn').removeClass('disable');
        $('#nav a[rel="' + currentNumber + '"]')
          .show()
          .prev("a")
          .show()
          .prev("a")
          .show()
          .prevAll("a")
          .hide();
        $('#nav a[rel="' + currentNumber + '"]')
          .next("a")
          .show()
          .next("a")
          .show()
          .nextAll("a")
          .hide();
      }
    })
    .find("#orderPagination a.active")
    .trigger("click");
}
function mobilepagination(mob_row_length) {
  $("#mobile-customPagination").html(
    '<div id="mob_nav"><div id="mobOrderPagination"></div></div>'
  );

  var rowsShown = 10;
  var rowsTotal = $(mob_row_length).length;
  var mobnumPages = Math.ceil(rowsTotal / rowsShown);
  var beforeLastPage = mobnumPages - 1;
  
  // console.log("mobnumPages", mobnumPages, mob_row_length);
  // console.log('rowsTotal',rowsTotal);

  noMargin($(".mobile-pagination"), mobnumPages)

  
  for (i = 1; i <= mobnumPages; i++) {
    $("#mobOrderPagination").append(
      '<a class="nums" href="javascript:void(0)" rel="' + i + '">' + i + "</a> "
    );

    if (i == 1 && mobnumPages > 4) {
      $("#mobOrderPagination").append('<span class="leftdot">...</span>');
    }
    if (i == beforeLastPage && mobnumPages > 4) {
      $("#mobOrderPagination").append('<span class="rightdot">...</span>');
    }
  }

  $(mob_row_length).hide();
  $(mob_row_length).slice(0, rowsShown).show();
  $("#mob_nav a:first").addClass("active");

  if (mobnumPages >= 2) {
    $("#mob_nav").append('<a class="next_btn" href="javascript:void(0)" rel="next"><span></span></a> ');
    $("#mob_nav").prepend('<a class="prev_btn" href="javascript:void(0)" rel="prev"><span></span></a> ');
  }
  if (mobnumPages > 4) {
    $("#mob_nav").find("rightdot").show();
  }
  if (mobnumPages <= 1) {
    $('#mob_nav').css('display','none');
  }else{
    $('#mob_nav').css('display','flex');
  }
  $("#mobOrderPagination a:gt(2)").hide(); // one after

  $("#mob_nav")
    .on("click", "a", function () {
      var pageNumber = $("#mob_nav .nums");
      var pageLength = $("#mob_nav .nums").length;
      var currentNumber = $(this).attr("rel");
      if(currentNumber == 1){
        $("#mob_nav").find('.prev_btn').addClass('disable');
      }else{
        $("#mob_nav").find('.prev_btn').removeClass('disable');
      }
      if (currentNumber == "next") {
        currentNumber = $("#mob_nav a.active").attr("rel");
        currentNumber++;
      } else if (currentNumber == "prev") {
        currentNumber = $("#mob_nav a.active").attr("rel");
        currentNumber--;
      }
      //console.log("numPages - currentNumber 121111111111", mobnumPages, currentNumber, mobnumPages - currentNumber);
      if (currentNumber > 4) {
        $("#mob_nav").find(".leftdot").show();
      } else {
        $("#mob_nav").find(".leftdot").hide();
      }
      if (currentNumber < 4) {
        $("#mob_nav").find(".rightdot").show();
        $("#mob_nav").find(".leftdot").hide();
      } else if (mobnumPages - currentNumber < 3) {
        $("#mob_nav").find(".rightdot").hide();
      } else {
        $("#mob_nav").find(".rightdot").hide();
      }
      //console.log('currentNumber',currentNumber);
      var r = currentNumber * rowsShown;
      var i = r - rowsShown;
      //console.log('rows',r);

      $("#mob_nav a").removeClass("active");
      $('#mob_nav a[rel="' + currentNumber + '"]').addClass("active");
      $(mob_row_length)
        .css("opacity", "0.0")
        .hide()
        .slice(i, r)
        .css("display", "table-row")
        .animate(
          {
            opacity: 1,
          },
          300
        );

      if (pageNumber.filter("#mobOrderPagination .active").is(pageNumber.first())) {
        console.log("test area first");
        if(pageLength <= 4){
          pageNumber.first('a').show().next('a').show().next('a').show().next('a').show();
        }else{pageNumber
          .first()
          .show()
          .next()
          .hide()
          .next()
          .show()
          .next()
          .show()
          .nextAll("a")
          .hide();}
        
        $("#mob_nav").find('.prev_btn').addClass('disable');
        $("#mob_nav").find('.next_btn').removeClass('disable');
      } else if (pageNumber.filter("#mobOrderPagination .active").is(pageNumber.last())) {
        //console.log("test area last mobile");
        $("#mob_nav").find('.prev_btn').removeClass('disable');
        $("#mob_nav").find('.next_btn').addClass('disable');
        $("#mob_nav").find(".rightdot").hide();
        //console.log('pageLength',pageLength);
        if(pageLength <= 4){
          //console.log('test-area in');
        pageNumber.last('a').show().prev('a').show().prev('a').show().prev('a').show();
        }else{
          //console.log('test-area out');
        pageNumber
          .last()
          .show()
          .prev()
          .hide()
          .prev()
          .show()
          .prev()
          .show()
          .prevAll("a")
          .hide();
        }
      } else {
        if (mobnumPages - currentNumber > 3) {
          $("#mob_nav").find(".rightdot").show();
        } else if (currentNumber == 4) {
          $("#mob_nav").find(".rightdot").hide();
        } else {
          $("#mob_nav").find(".rightdot").hide();
        }
        console.log("test area mobile out");
        $("#mob_nav").find('.prev_btn, .next_btn').removeClass('disable');
        $('#mob_nav a[rel="' + currentNumber + '"]')
          .show()
          .prev("a")
          .show()
          .prev("a")
          .show()
          .prevAll("a")
          .hide();
        $('#mob_nav a[rel="' + currentNumber + '"]')
          .next("a")
          .show()
          .next("a")
          .show()
          .nextAll("a")
          .hide();
      }
    })
    .find("#mobOrderPagination a.active")
    .trigger("click");
}
